import React, { useState } from 'react';
import ClayLayout from '@clayui/layout';
import MultiStep from '../../components/MultiStep/MultiStep';
import { PITCH_FORM_STEPS } from '../../utils/PitchFormConfig';
import FinalScreen from '../../components/FinalScreen/FinalScreen';
import OtpVerification from '../../components/OtpVerification/OtpVerification';
import PitchFormCompanyDetail from '../../components/PitchFormCompanyDetail/PitchFormCompanyDetail';
import PitchFormBusinessDetail from '../../components/PitchFormBusinessDetail/PitchFormBusinessDetail';

const PitchForm = () => {
    const [step, setStep] = useState<number>(0);
    const [resStatusCode, setResStatusCode] = useState(0);
    const [resStatusMessage, setResStatusMessage] = useState('');
    const activeStepKey = PITCH_FORM_STEPS[step]?.key;

    return (
        <ClayLayout.ContentSection className="contact_container">
            <ClayLayout.Row justify="start" className="contact_main">
                {/* <ClayLayout.Col sm={12} lg={5} className="contact_img p-0">
                    <img
                        src={
                            '/o/business-expansion-form-custom-element/images/banner.webp'
                        }
                    />
                </ClayLayout.Col> */}
                <ClayLayout.Col sm={12} lg={12} className="contact_form">
                    {step !== 4 && (
                        <MultiStep
                            step={step}
                            setStep={setStep}
                            steps={PITCH_FORM_STEPS}
                        />
                    )}

                    {activeStepKey === 'companyDetail' && (
                        <div className="personal-info-height pr-2">
                            <PitchFormCompanyDetail setStep={setStep} />
                        </div>
                    )}
                    {activeStepKey === 'email' && (
                        <OtpVerification setStep={setStep} btnUi="blue" />
                    )}
                    {activeStepKey === 'business' && (
                        <div className="personal-info-height pr-2">
                            <PitchFormBusinessDetail
                                setStep={setStep}
                                setResStatusMessage={setResStatusMessage}
                                setResStatusCode={setResStatusCode}
                            />
                        </div>
                    )}
                    {step == 3 && (
                        <div className="personal-info-height pr-2">
                            <FinalScreen
                                setStep={setStep}
                                resStatusMessage={resStatusMessage}
                                resStatusCode={resStatusCode}
                            />
                        </div>
                    )}
                </ClayLayout.Col>
            </ClayLayout.Row>
        </ClayLayout.ContentSection>
    );
};

export default PitchForm;
